import { AutoComplete, AutoCompletePortal } from "./auto-complete";
import { useAutoCompleteInputValue } from "./common";
import { AutoCompleteInput } from "./input";
import { AutoCompleteSingleInput } from "./single-input";
import { AutoCompleteList, AutoCompleteListItem } from "./list";
import type {
  AutoCompleteInputProps,
  AutoCompleteListItemProps,
  AutoCompleteListProps,
  AutoCompletePortalProps,
  AutoCompleteProps,
  AutoCompleteT,
} from "./props";

export {
  AutoComplete,
  AutoCompleteInput,
  AutoCompleteSingleInput,
  AutoCompletePortal,
  AutoCompleteList,
  AutoCompleteListItem,
  useAutoCompleteInputValue,
};

export type {
  AutoCompleteT,
  AutoCompleteProps,
  AutoCompletePortalProps,
  AutoCompleteInputProps,
  AutoCompleteListProps,
  AutoCompleteListItemProps,
};

export default {
  Root: AutoComplete,
  Input: AutoCompleteInput,
  SingleInput: AutoCompleteSingleInput,
  Portal: AutoCompletePortal,
  List: AutoCompleteList,
  ListItem: AutoCompleteListItem,
} satisfies AutoCompleteT<unknown>;
